"use strict";

var _regeneratorRuntime = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/arjunjain/Portfolio/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BigNum = require("@liskhq/bignum");

var lisk_cryptography_1 = require("@liskhq/lisk-cryptography");

var base_transaction_1 = require("./base_transaction");

var constants_1 = require("./constants");

var errors_1 = require("./errors");

var utils_1 = require("./utils");

exports.transferAssetFormatSchema = {
  type: 'object',
  properties: {
    data: {
      type: 'string',
      format: 'transferData',
      maxLength: 64
    }
  }
};

var TransferTransaction =
/*#__PURE__*/
function (_base_transaction_1$B) {
  _inherits(TransferTransaction, _base_transaction_1$B);

  function TransferTransaction(rawTransaction) {
    var _this;

    _classCallCheck(this, TransferTransaction);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransferTransaction).call(this, rawTransaction));
    var tx = typeof rawTransaction === 'object' && rawTransaction !== null ? rawTransaction : {};
    _this.asset = tx.asset || {};
    return _this;
  }

  _createClass(TransferTransaction, [{
    key: "assetToBytes",
    value: function assetToBytes() {
      var data = this.asset.data;
      return data ? Buffer.from(data, 'utf8') : Buffer.alloc(0);
    }
  }, {
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(store) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return store.account.cache([{
                  address: this.senderId
                }, {
                  address: this.recipientId
                }]);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }

      return prepare;
    }()
  }, {
    key: "verifyAgainstTransactions",
    value: function verifyAgainstTransactions(_) {
      return [];
    }
  }, {
    key: "validateAsset",
    value: function validateAsset() {
      utils_1.validator.validate(exports.transferAssetFormatSchema, this.asset);
      var errors = errors_1.convertToAssetError(this.id, utils_1.validator.errors);

      if (!utils_1.validateTransferAmount(this.amount.toString())) {
        errors.push(new errors_1.TransactionError('Amount must be a valid number in string format.', this.id, '.amount', this.amount.toString()));
      }

      if (!this.recipientId) {
        errors.push(new errors_1.TransactionError('`recipientId` must be provided.', this.id, '.recipientId'));
      }

      try {
        utils_1.validateAddress(this.recipientId);
      } catch (error) {
        errors.push(new errors_1.TransactionError(error.message, this.id, '.recipientId', this.recipientId));
      }

      if (this.recipientPublicKey) {
        var calculatedAddress = lisk_cryptography_1.getAddressFromPublicKey(this.recipientPublicKey);

        if (this.recipientId !== calculatedAddress) {
          errors.push(new errors_1.TransactionError('recipientId does not match recipientPublicKey.', this.id, '.recipientId', this.recipientId, calculatedAddress));
        }
      }

      return errors;
    }
  }, {
    key: "applyAsset",
    value: function applyAsset(store) {
      var errors = [];
      var sender = store.account.get(this.senderId);
      var balanceError = utils_1.verifyAmountBalance(this.id, sender, this.amount, this.fee);

      if (balanceError) {
        errors.push(balanceError);
      }

      var updatedSenderBalance = new BigNum(sender.balance).sub(this.amount);
      var updatedSender = Object.assign({}, sender, {
        balance: updatedSenderBalance.toString()
      });
      store.account.set(updatedSender.address, updatedSender);
      var recipient = store.account.getOrDefault(this.recipientId);
      var updatedRecipientBalance = new BigNum(recipient.balance).add(this.amount);

      if (updatedRecipientBalance.gt(constants_1.MAX_TRANSACTION_AMOUNT)) {
        errors.push(new errors_1.TransactionError('Invalid amount', this.id, '.amount', this.amount.toString()));
      }

      var updatedRecipient = Object.assign({}, recipient, {
        balance: updatedRecipientBalance.toString()
      });
      store.account.set(updatedRecipient.address, updatedRecipient);
      return errors;
    }
  }, {
    key: "undoAsset",
    value: function undoAsset(store) {
      var errors = [];
      var sender = store.account.get(this.senderId);
      var updatedSenderBalance = new BigNum(sender.balance).add(this.amount);

      if (updatedSenderBalance.gt(constants_1.MAX_TRANSACTION_AMOUNT)) {
        errors.push(new errors_1.TransactionError('Invalid amount', this.id, '.amount', this.amount.toString()));
      }

      var updatedSender = Object.assign({}, sender, {
        balance: updatedSenderBalance.toString()
      });
      store.account.set(updatedSender.address, updatedSender);
      var recipient = store.account.getOrDefault(this.recipientId);
      var balanceError = utils_1.verifyBalance(this.id, recipient, this.amount);

      if (balanceError) {
        errors.push(balanceError);
      }

      var updatedRecipientBalance = new BigNum(recipient.balance).sub(this.amount);
      var updatedRecipient = Object.assign({}, recipient, {
        balance: updatedRecipientBalance.toString()
      });
      store.account.set(updatedRecipient.address, updatedRecipient);
      return errors;
    }
  }, {
    key: "assetFromSync",
    value: function assetFromSync(raw) {
      if (raw.tf_data) {
        var data = raw.tf_data.toString('utf8');
        return {
          data: data
        };
      }

      return undefined;
    }
  }]);

  return TransferTransaction;
}(base_transaction_1.BaseTransaction);

TransferTransaction.TYPE = 0;
TransferTransaction.FEE = constants_1.TRANSFER_FEE.toString();
exports.TransferTransaction = TransferTransaction;